import { Button } from 'avo-ui'
import clsx from 'clsx'
import icFilterWhite from 'assets/images/ic-filter-white.svg'
import icFilter from 'assets/images/ic-filter.svg'
import ModalAdvanceFilter from 'components/commons/modal-advance-filter'
import Select from 'components/commons/select'

export const AdvanceFilter = ({
    show,
    setShow,
    filterDetail,
    getFilterCount,
    onSearchBrand,
    onChangeForm,
    onClear,
    optionsBrand,
    onSubmit,
}) => {
    return (
        <div>
            <div className={'w-fit relative'}>
                <Button
                    className={clsx(getFilterCount() > 0 && '!bg-blue-90 !text-white')}
                    title={'Filter'}
                    icon={getFilterCount() > 0 ? icFilterWhite : icFilter}
                    type={'outline'}
                    onClick={() => setShow(!show)}
                />
                <div
                    className={`absolute -right-1 -top-3.5 py-1 px-2.5 text-white bg-blue-95 rounded-full ${getFilterCount() > 0 ? 'block' : 'hidden'}`}
                >
                    {getFilterCount()}
                </div>
            </div>
            <ModalAdvanceFilter
                className={'!w-[425px]'}
                classNameContent={'!max-h-[500px] overflow-auto'}
                show={show}
                onHide={() => setShow(false)}
                title={'Filter'}
                onClear={onClear}
                onSubmit={() => onSubmit(filterDetail)}
            >
                <div className={'flex flex-col space-y-3 px-8 py-2 mb-40'}>
                    <div className={'font-semibold text-blue-90'}>Filter by Brand</div>
                    <Select
                        name={'brand_ids'}
                        className={'flex-1'}
                        optionsClassName={'max-h-40'}
                        placeholder={'Pilih brand'}
                        options={optionsBrand}
                        value={filterDetail?.brand_ids}
                        searchable
                        isMultiple
                        onChange={onChangeForm}
                        onSearch={onSearchBrand}
                    />
                </div>
            </ModalAdvanceFilter>
        </div>
    )
}
